import { render, staticRenderFns } from "./ButtonIcons.vue?vue&type=template&id=99ee2a4c"
import script from "./ButtonIcons.vue?vue&type=script&lang=js"
export * from "./ButtonIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports